import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API;

export default {
  state: {
    id: JSON.parse(localStorage.getItem("id")),
    token: JSON.parse(localStorage.getItem("token")),
    firebaseToken: JSON.parse(localStorage.getItem("firebaseToken")),
    username: JSON.parse(localStorage.getItem("username")),
    userType: JSON.parse(localStorage.getItem("userType")),
  },
  getters: {
    authenticated(state) {
      return state.token !== null;
    },
    id(state) {
      return state.id;
    },
    token(state) {
      return state.token
    },
    firebaseToken(state) {
      return state.firebaseToken
    },
    username(state) {
      return state.username;
    },
    isAdmin(state) {
      return state.userType === 'Admin';
    },
  },
  mutations: {
    SET_ID(state, id) {
      state.id = id;
      localStorage.setItem("id", JSON.stringify(state.id));
    },
    SET_TOKEN(state, token) {
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      state.token = token;
      localStorage.setItem("token", JSON.stringify(state.token));
    },
    SET_FIREBASE_TOKEN(state, token) {
      state.firebaseToken = token;
      localStorage.setItem("firebaseToken", JSON.stringify(state.firebaseToken));
    },
    SET_USERNAME(state, data) {
      state.username = data;
      localStorage.setItem("username", JSON.stringify(state.username));
    },
    SET_USERTYPE(state, data) {
      state.userType = data;
      localStorage.setItem("userType", JSON.stringify(state.userType));
    },
  },
  actions: {
    /**  Triggered on app mount to append axios bearer token */
    verifyToken({ state }) {
      if(state.token) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + state.token;
      }
    },
    register({ commit }, form) {
      return new Promise((resolve, reject) => {
        axios
          .post("register", form)
          .then((response) => {
            const token = response.data.token;
            const firebaseToken = response.data.firebaseToken;

            if (!token || !firebaseToken) return;

            commit("SET_ID", response.data.user.id);
            commit("SET_TOKEN", token);
            commit("SET_FIREBASE_TOKEN", firebaseToken);
            commit("SET_USERNAME", response.data.user.username);
            commit("SET_USERTYPE", response.data.user.userType.name);

            resolve();
          })
          .catch((error) => {
            reject(error.response.data);
          });
      });
    },
    login({ commit, getters }, form) {
      return new Promise((resolve, reject) => {
        axios
          .post("login", form)
          .then((response) => {
            const token = response.data.token;
            const firebaseToken = response.data.firebaseToken;

            if (!token || !firebaseToken) return;

            commit("SET_ID", response.data.user.id);
            commit("SET_TOKEN", token);
            commit("SET_FIREBASE_TOKEN", firebaseToken);
            commit("SET_USERNAME", response.data.user.username);
            commit("SET_USERTYPE", response.data.user.userType.name);

            resolve(getters.isAdmin);
          })
          .catch((error) => {
            reject(error.response.data.errors);
          });
      });
    },
    async logout({ commit }) {
      commit("SET_ID", null);
      commit("SET_TOKEN", null);
      commit("SET_FIREBASE_TOKEN", null);
      commit("SET_USERNAME", null);
      commit("SET_USERTYPE", null);

      axios.defaults.headers.common["Authorization"] = "";
    },
    updateUsername({ commit }, username) {
      commit('SET_USERNAME', username)
    },
    updateFirebaseToken({ commit }, firebaseToken) {
      commit('SET_FIREBASE_TOKEN', firebaseToken)
    }
  },
};
